<app-loader [isLoading]="isLoading"></app-loader>
<div class="user-wishlist-container d-flex flex-column">
  @if(isMobileDevice){
  <div class="rectangle-line-mobile-view" (click)="onClose()">
    <img src="../../../assets/images/rectangle-line.svg" />
  </div>
  }
  <div class="view-div" style="gap: 10px">
    @if(data?.favorites === 'like'){
    <span class="wishlist-text">My Favourites</span>
    } @else if(data?.transferRequest){
    <span class="wishlist-text">{{ data.wishlist.title || data.title }}</span>
    }@else {
    <div class="d-flex header align-items-center">

      <div class="date-div">
        <span class="wishlist-text">{{ data.wishlist.title || data.wishlist.name}}</span>
        @if(data.type=='centralizedPm'){
        <span class="refreshed-date-text">{{
          lastRefreshedDate
          ? " (Last Refreshed Date- " +
          lastRefreshedDate +
          "
          )"
          : ""
          }}</span>
        }
      </div>

      @if(data.wishlist.status==='P'){
      <span class="wishlist-text" style="font-size: 18px">Transferred to - {{ data.wishlist.name }}</span>
      }
      <div class="img-container" (click)="onClose()">
        <img src="../../../assets/images/crossIconDarkTheme.svg" class="cross-icon" />
      </div>
    </div>

    } @if(isMobileDevice){
    <div class="mob-filter">
      @if(data.type === 'centralizedPm' && !data.favorites){
      <div class="d-flex flex-row">
        <button class="dp-primary-btn me-2" (click)="openFilterDialog()">
          <img src="assets/filter.svg" />
        </button>
        @if(appliedFilters){
        <button type="button" class="dp-destructive-btn" style="padding: 10px 12px;"
          (click)="appliedFilters=undefined;fetchUserWishlistReport()">
          &#10006;
        </button>
        }
      </div>
      <div class="filter-div">
        <div class="d-flex flex-column input-div">
          <span class="input-text">Enter field level user</span>
          <input class="wishlist-input dp-input-control" placeholder="Search by Field User Name" aria-label="Search"
            [formControl]="fieldWorkerName" [matAutocomplete]="autoId" (click)="fetchUsers()" />

          <mat-autocomplete autoActiveFirstOption #autoId="matAutocomplete">
            @for (item of filterUserWishlist ; track item) {
            <mat-option [value]="item.name" (onSelectionChange)="onSelectionUser(item)" class="userNameEmail">
              <div>{{ item.name }}</div>
              <div style="color: var(--text-tertiary);">{{ item.email }}</div>
            </mat-option>
            }
          </mat-autocomplete>
        </div>
        <div class="d-flex flex-column input-div">
          <span class="input-text">Enter User serialNo</span>
          <input class="dp-input-control wishlist-input" [(ngModel)]="memKey" (ngModelChange)="onMemkeySearch($event)"
            placeholder="Search by user serialNo" />
        </div>
      </div>
      }
      <!-- @if(data.type==='centralizedPm' && !data.favorites){
          <mat-form-field class="select-mat-form-field" style="width: 15rem">
            <mat-select
              class="custom-mat-select"
              [formControl]="filterValue"
              placeholder="Select status"
              >@for(option of filterOptions;track option){
              <mat-option (click)="onSelect(option.id)" [value]="option.name">
                {{ option.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        } -->
      <div class="print-button">
        @if(data?.favorites === 'like' && showPrintBtn){
        <button class="dp-primary-btn print-btn" (click)="printPDF(true)">
          Print
        </button>
        } @else if(showPrintBtn && (userWishlists.length>0 ||
        printAndMonitorUserWishlists.length>0)){
        <button class="dp-primary-btn print-btn" (click)="printPDF()">
          Print
        </button>
        }
      </div>
    </div>
    }
  </div>
  @if(!isMobileDevice){
  <!-- <div class="d-flex justify-content-between"> -->
  <div class="d-flex align-items-center" (click)="onClose()">
    <img src="../../../assets/images/back-icon.svg" class="cross-icon" />
    <span class="wishlist-back ms-2" style="cursor: pointer">Back to all wishlists</span>
  </div>
  <div class="filter">
    @if(data.type === 'centralizedPm' && !data.favorites){
    <div class="filter-div">
      <button class="dp-primary-btn" (click)="openFilterDialog()">
        <img src="assets/filter.svg" />
      </button>
      @if(appliedFilters){
      <button type="button" class="dp-destructive-btn" style="padding: 10px 12px;"
        (click)="appliedFilters=undefined;fetchUserWishlistReport()">
        &#10006;
      </button>
      }
      <!-- <div class="d-flex flex-column input-div">
        <span class="input-text">Select Status</span>
        <mat-form-field class="select-mat-form-field" style="width: 15rem">
          <mat-select
            class="custom-mat-select"
            [formControl]="filterValue"
            placeholder="Select status"
            >@for(option of filterOptions;track option){
            <mat-option (click)="onSelect(option.id)" [value]="option.name">
              {{ option.name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div> -->
      <div class="d-flex flex-column input-div">
      <span class="input-text">Select View</span>
      <div class="state-filter">
      <mat-form-field class="select-mat-form-field custom-select-form drop-width">
        <mat-select class="custom-mat-select custom-select" id="state" placeholder="Select State"
          [formControl]="view" (selectionChange)="onViewChange($event)">
          <mat-option *ngFor="let item of viewOptions; let i=index" [value]="item.value">
            {{ item.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
      </div>
    
      <div class="d-flex flex-column input-div">
        <span class="input-text">Enter Field Level User</span>
        <input class="wishlist-input dp-input-control" type="tel" placeholder="Search by Field User Name"
          aria-label="Search" [formControl]="fieldWorkerName" [matAutocomplete]="autoId" (click)="fetchUsers()" />

        <mat-autocomplete autoActiveFirstOption #autoId="matAutocomplete">
          @for (item of filterUserWishlist ; track item) {
          <mat-option [value]="item.name" (onSelectionChange)="onSelectionUser(item)" class="userNameEmail">
            <div>{{ item.name }}</div>
            <div style="color: var(--text-tertiary);">{{ item.email }}</div>
          </mat-option>
          }
        </mat-autocomplete>
      </div>
      <div class="d-flex flex-column input-div">
        <span class="input-text">Enter User SerialNO</span>
        <input class="dp-input-control wishlist-input" [(ngModel)]="memKey" (ngModelChange)="onMemkeySearch($event)"
          placeholder="Search by user serialNo" />
      </div>
    </div>
    } @if(showPrintBtn && (userWishlists.length>0 ||
    printAndMonitorUserWishlists.length>0)){ @if(data?.favorites === 'like'){
    <button class="dp-primary-btn print-btn" (click)="printPDF(true)">
      Print
    </button>
    } @else {
    <button class="dp-primary-btn print-btn" (click)="printPDF()">Print</button>
    } }
  </div>
  <!-- </div> -->

  } @if(!isMobileDevice && data.type != 'centralizedPm'){
  <div class="table-container dp-table-scroll" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="1000" (scrolled)="onScroll()">
    <dp-table [dataTable]="userWishlists" [displayedColumns]="displayColumnData" [componentMap]="cellComponentMap"
      (cellClick)="onCellClick($event)"></dp-table>
  </div>
  } @else if (data.type == 'centralizedPm') { @if(data.type == 'centralizedPm'
  && !isMobileDevice){
  <div class="table-container dp-table-scroll" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="1000" (scrolled)="onScroll()">
    <dp-table [dataTable]="printAndMonitorUserWishlists" [displayedColumns]="displayPrintAndMonitorColumnData"
      [componentMap]="cellComponentPrintAndMonitorMap" [enableRowClick]="true" (rowData)="onClickRowData($event)"
      (cellClick)="onCellClick($event)"></dp-table>
  </div>
  }@else{
  <div class="tableBoxMob mt-3">
    <div class="dp-table-scroll" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="1000">
      @for( lists of printAndMonitorUserWishlists; track lists){
      <ul class="eachdataList">
        <li class="data">
          SL. NO
          <span #tooltip="matTooltip" matTooltipPosition="below" (click)="tooltip.show()" matTooltip="Sl no. copied"
            [cdkCopyToClipboard]="lists.slno" class="serial-no">{{ lists.SL_NO }}</span>
        </li>

        <li class="data">
          Name
          <span>{{ lists.dikshyarthi_name || lists.dikshyatri_name }}</span>
        </li>

        <li class="data">
          Guardian Name <span>{{ lists.guardian_name }}</span>
        </li>

        <li class="data">
          Ritwik Name<span>{{ lists.ritwiki_name }}</span>
        </li>
        @if(data.canAccessContact){
         <li class="data">
          Contact Number<span [style.color]="lists.isDefaulter ? 'var(--brand-primary)' : ''" (click)="$event.stopPropagation();onContactClick(lists)">{{ lists.contactNo || '--'}}</span>
        </li>
      }
        @if(!data.viewType){
        <li class="data">
          Initiation Date<span>{{ lists.initiation_date }}</span>
        </li>
      }@else{
         <li class="data">
          Last IV Date<span>{{ lists.lastIstavrityDate }}</span>
        </li>
      }

      @if(data.viewType){
         <li class="data">
          Updated By<span>{{ lists.fwUpdatedByName }}</span>
        </li>
      }
       @if(data.viewType || data.recordStatus){
         <li class="data">
          Updated Address<span>{{ lists.updatedAddress }}</span>
        </li>
      }
        <!-- <li class="data">
          Initiation Date <span>{{ lists.initiation_date }}</span>
        </li> -->

        <li class="data">
          Address <span>{{ lists.permanent_address }}</span>
        </li>
        <div class="secondary-button">
          <!-- <button
                    class="dp-secondary-btn hover-btn flex-grow"
                    (click)="openTransferWishlistDialog()"
                  >
                    Transfer data
                  </button> -->
          @if (data.wishlist?.status != 'P' && (data.perm == true || lists.canDelete) ) {
          <!-- <button class="dpnf-btn" (click)="onCellClick(lists)">
            <span class="ms-1">Delete</span>
          </button> -->
           <button class="dp-secondary-btn" (click)="onCellClick(lists, 'delete')">
            <img src='../../assets/images/delete-cell.svg' />
          </button>
          }
          @if([1,3,4].includes(lists.record_status)){
          <button class="dp-secondary-btn btn-padding" [disabled]="lists.isVisitedByMe===1"
            (click)="$event.stopPropagation(); onCellClick({rowData:lists, type:'Add details'})" [class.disabled]="lists.isVisitedByMe===1">
            <!-- <span>Add visit</span> -->
            @if(lists.isVisitedByMe===1){
            <div class="tick" style="background:var(--disc-tick)"></div>
            }
            <div class="heart-div" style="background:var(--location)"></div>
          </button>
          <button class="dp-secondary-btn btn-padding" [disabled]="lists.visit_count===0"
            (click)="$event.stopPropagation(); onCellClick({rowData:lists, type:'Visit history'})" [class.disabled]="lists.visit_count===0">
            <!-- <span>Visit history</span> -->
            @if(lists.visit_count!==0){
            <div class="visit-count">{{lists.visit_count}}</div>
            }
            <div class="heart-div" style="background:var(--visit-history)"></div>
          </button>
          }
          <!-- @if(lists.canDelete || lists.canDelete == undefined){
          <button class="dp-secondary-btn  delete-btn" (click)="onCellClick('delete')">
            <img src='../../assets/images/delete-cell.svg' />
          </button>
          } -->
          @if(![1,3,4].includes(lists.record_status) && lists.isDefaulter == 1 && lists.canReach && lists.mem_status == 2){
          <button class="dp-primary-btn btn-padding" (click)="$event.stopPropagation(); onCellClick({rowData:lists, type:'reach'})">Reach</button>
          }@else if(isReached){
          <button class="dp-secondary-btn btn-padding"><img src="../../assets/images/tick-gold.svg" /></button>
          }
          @if(lists.canInactive && ![1,3,4].includes(lists.record_status)){
          <button class="dp-secondary-btn btn-padding" (click)="$event.stopPropagation(); onCellClick({rowData:lists, type:'inactive'})">Deceased</button>
          }
          <button class="dp-secondary-btn btn-padding" (click)="onClickRowData(lists)">...</button>
        </div>
      </ul>
      }
    </div>
  </div>
  } } @else if(isMobileDevice){
  <div class="tableSec">
    <div class="tableBoxMob">
      <div class="dataList dp-table-scroll" style="height: 60vh !important" infiniteScroll [scrollWindow]="false"
        [infiniteScrollDistance]="1" [infiniteScrollThrottle]="1000" (scrolled)="onScroll()">
        @if(userWishlists.length>0){ @for( lists of userWishlists; track lists){
        <ul class="eachdataList">
          <li class="data">
            Name<span>{{ lists.mNm ? lists.mNm : "-" }}</span>
          </li>
          <li class="data">
            Sl.No
            <span class="serial-no">{{
              lists.serialNo ? lists.serialNo : "-"
              }}</span>
          </li>
          <li class="data">
            Family code <span>{{ lists.fc ? lists.fc : "-" }}</span>
          </li>
          <li class="data">
            Ritwik name <span>{{ lists.rNm ? lists.rNm : "-" }}</span>
          </li>
          <li class="data">
            Address <span>{{ lists.addr ? lists.addr : "-" }}</span>
          </li>
          <li class="data">
            Contact <span>{{ lists.contact ? lists.contact : "-" }}</span>
          </li>
          <li class="data">
            Transferred by
            <span>{{
              lists.transferredByEmail ? lists.transferredByEmail : "-"
              }}</span>
          </li>
          <div class="secondary-button">
            <!-- <button
                  class="dp-secondary-btn hover-btn flex-grow"
                  (click)="openTransferWishlistDialog()"
                >
                  Transfer data
                </button> -->
            @if (data.wishlist?.status != 'P') {
            <button class="dpnf-btn" (click)="onCellClick(lists)">
              <span class="ms-1">Delete</span>
            </button>
            }
          </div>
        </ul>
        } } @else {
        <div class="noData">
          <div class="placeholderTable"></div>
          <p>No data found!</p>
        </div>
        }
      </div>
    </div>
  </div>
  } @if(!data?.transferRequest && data.wishlist?.status != 'P' && data.favorites
  != 'like' && data.type == 'centralizedFd' && !isMobileDevice &&
  userWishlists.length>0){
  <div class="d-flex justify-content-end" *ngIf="userWishlists.length > 0">
    <button class="dp-primary-btn transfer-btn" (click)="openTransferWishlistDialog()">
      Transfer entire wishlist
    </button>
  </div>
  } @else if(!data?.transferRequest && data.wishlist?.status != 'P' &&
  data.favorites != 'like' && data.type == 'centralizedFd' && isMobileDevice &&
  userWishlists.length>0){
  <div class="for-mobile-view-action" *ngIf="userWishlists.length > 0">
    <button class="dp-primary-btn transfer-btn" (click)="openTransferWishlistDialog()">
      Transfer entire wishlist
    </button>
  </div>
  } @if(data.type != 'centralizedPm' ){
  <div class="d-flex justify-content-end" *ngIf="printAndMonitorUserWishlists.length > 0">
    <button class="dp-primary-btn transfer-btn" (click)="deleteEntireWishlistDialog()">
      Delete entire wishlist
    </button>
  </div>
  }
</div>
<app-loader [isLoading]="isLoading"></app-loader>